<h1 mat-dialog-title>Mitglied entfernen</h1>
<div mat-dialog-content>
    <p class="dialog-text">
        Soll das Mitglied {{ data.username }} wirklich entfernt werden?
    </p>
    <div>
        <h3>Begründung:</h3>
        <textarea [(ngModel)]="message" placeholder="Begründung für das Entfernen"></textarea>
    </div>
</div>
<div mat-dialog-actions align="center">
    <button matButton="elevated" (click)="onClick(false)" color="warn" cdkFocusInitial>
        Abbrechen
    </button>
    <button matButton="elevated" (click)="onClick(true)" class="green-confirm" cdkFocusInitial>
        Bestätigen
    </button>
</div>